/*------------------------------------*\
    tabs
\*------------------------------------*/

module.exports = function(){


    // Update hash and content on trigger click


    function openTab(){

        // dirty quick hack
        // the problem:
        // hash from <a href="#..."> gets added after execution of this scrollToTab() function (should be before)
        setTimeout(function(){

            var windowHash = location.hash.split('#')[1];
            var $currentTab = $('.js-tab[data-tab="' + windowHash + '"]');
            var $currentTabHash = $('.js-tab-trigger[href*="#' + windowHash + '"]');

            $('.js-tab').removeClass('is-current');
            $currentTab.addClass('is-current');

            $('.js-tab-trigger').removeClass('is-current');
            $currentTabHash.addClass('is-current');


            if (!windowHash) {
                $('.js-tab').eq(0).addClass('is-current');
                $('.js-tab-trigger').eq(0).addClass('is-current');
            }



            $currentTab.trigger('tabopen');

        }, 1);



    }


    $('.js-tab-trigger').on('click', function() {
        openTab();
    });




    $(document).on('ready', function(event) {
        setTimeout(function(){
            openTab();
        }, 100);
    });




    $(document).on('ready', function(event) {

        if (getget('order')) {

            if (getget('order') != 'showtab') {
                var containerSelector = '[js-order="' + getget('order') + '"]';
                var $orderAccordionContainer = $(containerSelector);
                var $orderAccordionHeader = $orderAccordionContainer.prev('.js-accordion-heading');
            }


            var $orderTabBtn = $('.js-tab-trigger[href="#orders"]');
            var $orderTabContainer = $('.js-tab[data-tab="orders"]');


            setTimeout(function(){

                $('.js-tab-trigger').removeClass('is-current');
                $('.js-tab').removeClass('is-current');

                $orderTabBtn.addClass('is-current');
                $orderTabContainer.addClass('is-current');

            }, 1000);


            if (getget('order') != 'showtab') {

                setTimeout(function(){
                    $orderAccordionHeader.addClass('is-active');
                    $orderAccordionHeader.addClass('is-highlighted');
                    $orderAccordionContainer.addClass('is-active');
                    $orderAccordionContainer.addClass('is-highlighted');


                }, 1200);


                setTimeout(function(){

                    $('html, body').animate({
                        scrollTop: $orderAccordionHeader.offset().top - 50
                    }, 200);

                }, 1500);

            }



        }


    });



}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/tabs.js